import { ApiBase } from '../apiBase';
import { ApiDailyControlBase } from './ApiDailyControlBase';
import { DailyControlUser } from './models/UserModels';

export class ApiDailyControlUser extends ApiDailyControlBase {
  public static override get baseUrl(): string {
    return `${ApiDailyControlBase.baseUrl}/users`;
  }

  public static async index(params: {
    page?: number;
    size?: number;
    search?: string;
    expiring?: boolean;
    low_credits?: boolean;
    sort_field?: string;
    sort_direction?: 'asc' | 'desc';
  }) {
    const response = await ApiBase.get(this.baseUrl, params);

    return response.data.data as {
      total: number;
      users: DailyControlUser[];
    };
  }
}
